<template>
	<div :class="bemm()">
		<div :class="bemm('message')">
			<h2 :class="bemm('title')">{{ t('maintenance.title') }}</h2>
			<p>{{ t('maintenance.intro') }}</p>
			<p>{{ t('maintenance.upgradeNotice') }}</p>
			<p>{{ t('maintenance.apology') }}</p>
			<p>
				{{ t('maintenance.supportLead') }}
				<a
					:class="bemm('support-link')"
					:href="`mailto:${t('maintenance.supportEmail')}`"
					>{{ t('maintenance.supportEmail') }}</a
				>.
			</p>
			<p>{{ t('maintenance.signoff') }}</p>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useBemm } from 'bemm';

const { t } = useI18n();
const bemm = useBemm('maintenance', {
	return: 'string',
	includeBaseClass: true,
});
</script>

<style lang="scss">
.maintenance {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
	background-color: var(--color-background);

	&__message {
		background-color: var(--color-surface);
		border: 1px solid var(--color-border);
		border-radius: var(--border-radius);
		padding: var(--space);
		max-width: 600px;
		color: var(--color-foreground);

		p {
			line-height: 1.6;
			margin-bottom: var(--space-s);
		}
	}

	&__title {
		text-align: center;
		margin-bottom: var(--space);
	}

	&__support-link {
		color: var(--color-secondary);
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
}
</style>
